'use strict';
// Object.defineProperty(exports, '__esModule', { value: true });
// exports.KeyPair = void 0;
export class KeyPair {
  constructor(publicKey, privateKey, address) {
        this._publicKey = publicKey;
        this._privateKey = privateKey;
        this._address = address;
    }
    get publicKey() {
        return this._publicKey;
    }
    get privateKey() {
        return this._privateKey;
    }
    get address() {
        return this._address;
    }
}
// exports.KeyPair = KeyPair;
//# sourceMappingURL=keyPair.js.map